"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_item_style_1 = require("../../../components/menu/menu.item.style");
const theme_1 = require("../../../components/theme");
const theme_util_1 = require("../../../components/theme.util");
exports.CSS = {
    container: 'c-FormEditFieldInfo',
    section: {
        container: 'c-FormEditFieldInfo__section',
        final: 'c-FormEditFieldInfo__section--final',
    },
    move: 'c-FormEditFieldInfo__move',
    title: 'c-FormEditFieldInfo__title',
    type: 'c-FormEditFieldInfo__type',
    menu: 'c-FormEditFieldInfo__menu',
    input: {
        container: 'c-FormEditFieldInfo__input',
        title: 'c-FormEditFieldInfo__inputTitle',
        value: 'c-FormEditFieldInfo__inputValue',
    },
    option: 'c-FormEditFieldInfo__option',
    optionButton: 'c-FormEditFieldInfo__optionButton',
    isOptionActive: 'c-FormEditFieldInfo__option--is-active',
};
exports.Style = {
    [exports.CSS.container]: Object.assign(Object.assign({ display: 'flex', 'flex-direction': 'column' }, theme_util_1.IkeCssUtil.padding(1, 8)), { position: 'relative' }),
    [exports.CSS.section.container]: {
        display: 'flex',
        'align-items': 'center',
    },
    [exports.CSS.section.final]: {
        'margin-bottom': theme_1.DefaultTheme.space(8),
        'flex-wrap': 'wrap',
    },
    [exports.CSS.menu]: {
        [`& .${menu_item_style_1.CSS.item}`]: {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6),
        },
    },
    [exports.CSS.title]: theme_util_1.IkeCssUtil.Flex.centerVertical,
    [exports.CSS.type]: {
        'align-items': 'center',
        '& > i': {
            margin: `0 ${theme_1.DefaultTheme.space(1)}`,
        },
    },
    [exports.CSS.option]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    [exports.CSS.input.container]: {
        'margin-right': theme_1.DefaultTheme.space(4),
        height: theme_1.DefaultTheme.space(8),
        display: 'flex',
        cursor: 'default',
    },
    [exports.CSS.option]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    [exports.CSS.input.value]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    [exports.CSS.input.title]: Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { 'margin-right': theme_1.DefaultTheme.space(2), 'font-weight': 'bold', overflow: 'hidden' }),
    [exports.CSS.move]: Object.assign(Object.assign(Object.assign({}, theme_util_1.IkeCssUtil.absolute(2, 1)), theme_util_1.IkeCssUtil.Flex.column), { width: theme_1.DefaultTheme.space(8) }),
};
//# sourceMappingURL=form.info.panel.style.js.map